export const SpinnerSizes = {
  factor: 9,
  top: 24,
};
